import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// This function checks if the user is an admin. You can adapt this to get the user role from context, Redux, or localStorage.
const checkIfAdmin = (userRole) => {
  // Check if the user is logged in and if they have the 'admin' role.
  //const user = JSON.parse(localStorage.getItem('user')); // Assuming user information is stored in localStorage
  //const [userRole] = useState(localStorage.getItem('userRole'));
  return userRole === 'admin'; // Make sure the role is 'admin'
};

const ProtectedRoute = () => {
  const [userRole] = useState(localStorage.getItem('userRole'));
  // If the user is not an admin, redirect them to the login page (or any other page you prefer)
  if (!checkIfAdmin(userRole)) {
    return <Navigate to="/login" />;
  }
  // If the user is an admin, render the child components (the protected route)
  return <Outlet />;
};

export default ProtectedRoute;
